import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { finalize, map, Observable, of, tap } from 'rxjs';
import { VendorService } from '../services/vendor-service';
import { RouterModule } from '@angular/router';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';

@Component({
  selector: 'app-outstanding-report',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatGridListModule,
    RouterModule,
    MatDialogModule,
    MatSpinner,
    MatPaginatorModule
  ],
  templateUrl: './outstanding-report.component.html',
  styleUrl: './outstanding-report.component.css'
})
export class OutstandingReportComponent {
  constructor(private vendorService: VendorService, private dialog: MatDialog) { }
  displayedColumns: string[] = [
    'slno',
    'name',  
    'date',
    'due_date',   
    'amount_total',
    'status'
  ];
  isLoading = false;
  outstandingReport$!: Observable<any[]>;
  pageSize = 10;
  pageIndex = 0;

  ngOnInit() {
    this.getOutstandingReport();
  }

  getOutstandingReport() {
    this.isLoading = true;
    this.outstandingReport$ = this.vendorService.getOutstandingReport().pipe(
      map((res: any) => res.result.data),
      finalize(() => this.isLoading = false)
    );
  }

  onPageChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
  }

}
